import React, { Component } from 'react';
import TopNav from './TopNav';
import MegaNav from './MegaNav';
import VideoModal from './video-modal/VideoModal';
import SkipToMainContent from './SkipToMainContent';

class HeaderContainer extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <header>
        <SkipToMainContent/>
        <TopNav props={this.props} />
        <MegaNav props={this.props} />
      </header>
    );
  }
}

export default HeaderContainer;
